import FormLogin from 'components/Forms/FormLogin/FormLogin'
import FormWithoutLogin from 'components/Forms/FormWithoutLogin/FormWithoutLogin'
import InfoWindow from 'components/Windows/InfoWindow/InfoWindow'
import useErrorMessage from 'components/Windows/InfoWindow/hooks/useErrorMessage'
import ChooseHeader from 'pages/ContactInfo/components/ChooseHeader/ChooseHeader'
import hocConnect from 'pages/Login/hocLogin'
import { useState } from 'react'
import { useIntl } from 'react-intl'

function ContactInfo({
    setUserInfo,
    login,
    error,
    loading,
    loginUsingFacebook,
    loginUsingGoogle,
    loginSocialsError,
    loginUsingApple,
}) {
    const intl = useIntl()
    const [isLoginForm, setIsLoginForm] = useState(true)
    const errorMessage = useErrorMessage(error?.message)

    const onSubmitWithoutLogin = (values) => {
        setUserInfo(values)
    }

    return (
        <div className={'contact-info-page--content d-flex flex-column mx-auto'}>
            {error && <InfoWindow color={'red'} description={errorMessage} withScroll withTimer />}
            <div className={'contact-info-page--forms d-flex'}>
                <ChooseHeader isLoginForm={isLoginForm} setIsLoginForm={setIsLoginForm} />
                {isLoginForm ? (
                    <FormLogin
                        title={intl.formatMessage({ id: 'contactInfo.haveAccount' })}
                        handleSubmit={login}
                        handleGoogle={loginUsingGoogle}
                        handleFacebook={loginUsingFacebook}
                        handleSocialsError={loginSocialsError}
                        handleApple={loginUsingApple}
                        formErrors={error}
                        loading={loading}
                    />
                ) : (
                    <FormWithoutLogin
                        title={intl.formatMessage({ id: 'contactInfo.buyWithoutLogin' })}
                        handleSubmit={(values) => onSubmitWithoutLogin(values)}
                    />
                )}
                <FormWithoutLogin
                    title={intl.formatMessage({ id: 'contactInfo.buyWithoutLogin' })}
                    className={'without-login'}
                    handleSubmit={(values) => onSubmitWithoutLogin(values)}
                />
            </div>
        </div>
    )
}

export default hocConnect(hocConnect(ContactInfo))
